<template>
  <!--карточки маленькие и средние-->
  <a
    class="bim-product-card"
    :href="link"
    :class="{ 'bim-product-card--wide': type === 'wide' }"
    v-bind="$attrs"
    :style="cardStyle"
    v-if="smallCard"
  >
    <div class="bim-product-card__top">
      <bimImg
        class="bim-product-card__image"
        itemprop="contentUrl"
        :src="imageSrc"
        :alt="name"
        :lazy="lazyImage"
      />
      <span
        v-if="manufacturer.image"
        class="bim-product-card__manufactirer-link"
        @click.stop.prevent="companyClicked"
      >
        <bimImg
          class="bim-product-card__manufactirer-image"
          :src="manufacturer.image"
          :alt="manufacturer.name"
          :lazy="lazyImage"
        />
      </span>
    </div>
    <div class="bim-product-card__bottom">
      <h5 class="bim-product-card__title" itemprop="name">{{ name }}</h5>
      <p class="bim-product-card__category" v-if="type === 'wide'">{{ description }}</p>
    </div>
    <div
      title="Производитель запрашивает контакты для скачивания этой модели"
      v-if="showLockIcon"
      v-html="require('@/assets/img/verified-primary.svg')"
      class="bim-product-card__verified-icon"
      width="14px"
      height="14px"
    ></div>
  </a>

  <!--самая большая карточка-->
  <div v-else class="bim-card-big" v-bind="$attrs">
    <div class="big-image-cnt">
      <img class="bim-image-skelet" :src="bigWideSkelet" />
      <bimImg class="bim-image" :src="imageBigSrc" :alt="name" :lazy="lazyImage" />
      <span
        v-if="manufacturer.image"
        class="bim-product-card__manufactirer-link big-wide"
        @click.stop.prevent="companyClicked"
      >
        <bimImg
          class="bim-product-card__manufactirer-image"
          :src="manufacturer.image"
          :alt="manufacturer.name"
          :lazy="lazyImage"
        />
      </span>
    </div>
    <div class="bim-text-cnt">
      <div class="big-card-title">
        <bim-text-main :bold="true">{{ name }}</bim-text-main>
      </div>
      <div class="big-card-desc">
        <bim-text-medium class="big-card-desc-text">
          <span v-html="description"></span>
        </bim-text-medium>
      </div>
      <div class="big-card-btn" v-if="btnName">
        <bim-button
          :label="btnName"
          size="l"
          @click="btnClicked"
          :color="borderHoverColor"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import bimButton from '@/components/form/bimButton/bimButton'
  import bimTextMain from '@/components/text/bimTextMain/bimTextMain'
  import bimTextMedium from '@/components/text/bimTextMedium/bimTextMedium'
  import bimImg from '@/components/ui/bimImg/bimImg'
  import Uri from 'jsuri'

  export default {
    name: 'bimProductCard',
    components: {
      bimButton,
      bimTextMain,
      bimTextMedium,
      bimImg
    },
    props: {
      /**
       * src изображения модели
       */
      image: {
        type: String,
      },
      /**
       * Использовать асинхронную подгрузку картинки по мере скрола
       */
      lazyImage: {
        type: Boolean,
        default: false
      },
      /**
       * Наименование модели
       */
      name: {
        type: String,
        required: true
      },
      /**
       * Описание модели
       */
      description: {
        type: String
      },
      /**
       * Наименование кнопки
       */
      btnName: {
        type: String,
      },
      /**
       * Ссылка на модель
       */
      link: {
        type: String
      },
      /**
       * Размер Карточки
       */
      type: {
        type: String,
        default: 'card',
        validator (value) {
          return ['card', 'wide', 'big-wide'].indexOf(value) !== -1
        }
      },
      /**
       * Ширина карточки. Если число без величины, будет px.
       */
      width: {
        type: [String, Number],
        default: 140
      },
      /**
       * Высота карточки. Если число без величины, будет px.
       */
      height: {
        type: [String, Number],
        default: 232
      },
      /**
       * Производитель
       */
      manufacturer: {
        type: Object,
        default: () => ({}),
        prop: {
          link: String, // ссылка
          name: String, // наименование
          image: String // картинка
        }
      },
      /**
       * Цвет бордера при наведении на карточку
       */
      borderHoverColor: {
        type: String,
        default: '#00afa1'
      },
      /**
       * Показывать иконку замка на карточке модели
       */
      showLockIcon: Boolean
    },
    data () {
      return {
        bigWideSkelet: 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMuaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA2LjAtYzAwMiA3OS4xNjQzNTIsIDIwMjAvMDEvMzAtMTU6NTA6MzggICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTM0MDZGOUY1NTExRUFBQzBBRUE3ODdBRUVEOTEyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc5QTM0MDcwOUY1NTExRUFBQzBBRUE3ODdBRUVEOTEyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzlBMzQwNkQ5RjU1MTFFQUFDMEFFQTc4N0FFRUQ5MTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzlBMzQwNkU5RjU1MTFFQUFDMEFFQTc4N0FFRUQ5MTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgICAgICAgICAgIDAwMDAwMDAwMDAQEBAQEBAQIBAQICAgECAgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwP/wAARCAADAAUDAREAAhEBAxEB/8QASgABAAAAAAAAAAAAAAAAAAAACgEBAAAAAAAAAAAAAAAAAAAAABABAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AfwD/2Q=='
      }
    },
    computed: {
      imageSrc () {
        return this.formImage('200x-')
      },

      imageBigSrc () {
        return this.formImage('300x-')
      },

      smallCard () {
        return ~['card', 'wide'].indexOf(this.type)
      },
      cardStyle () {
        return {
          width: this.computedWidth,
          height: this.computedHeight,
          '--hovercolor': this.borderHoverColor,
        }
      },
      computedHeight () {
        if (+this.height) {
          return this.height + 'px'
        } else {
          return this.height
        }
      },

      computedWidth () {
        if (+this.width) {
          return this.width + 'px'
        } else {
          return this.width
        }
      }
    },
    methods: {
      formImage (size) {
        return new Uri(this.image).addQueryParam('size', size).toString()
      },

      btnClicked () {
        this.$emit('btnClicked')
      },
      companyClicked (e) {
        e.stopPropagation()
        e.preventDefault()

        if (!this.manufacturer) {
          return
        }

        if (!this.manufacturer.link) {
          return
        }

        window.location = this.manufacturer.link
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bim-product-card {
    display          : inline-flex;
    flex-direction   : column;
    border-radius    : 10px;
    box-shadow       : 0 3px 8px 0 rgba(0, 0, 0, 0.05);
    border           : solid .5px $white-color-500;
    background-color : $white-color;
    text-decoration  : none;
    overflow         : hidden;
    cursor           : pointer;
    transition       : all .2s;
    position         : relative;

    &:hover {
      border-color : var(--hovercolor);
      box-shadow   : none;

      .bim-product-card__top {
        border-color : $white-color-500;
      }

      .bim-product-card__manufactirer-link {
        opacity : 1;
      }
    }

    &:active {
      border-color     : $white-color-100;
      background-color : $white-color-100;
    }

    .bim-product-card__top {
      border-color : $white-color-300;
    }
  }

  .bim-product-card__verified-icon {
    position: absolute;
    right: 9px;
    bottom: 6px;

    ::v-deep {
      svg {
        width: 14px;
        height: 14px;
      }
    }
  }

  .bim-product-card__top {
    box-sizing      : border-box;
    display         : flex;
    align-items     : center;
    justify-content : center;
    position        : relative;
    border-bottom   : 1px solid $white-color-300;
    height          : 128px;
  }

  .bim-product-card__image {
    @include size(100px);
    object-fit : contain;
    max-width  : 100%;
    max-height : 100%;
  }

  .bim-product-card__manufactirer-link {
    display         : flex;
    align-items     : center;
    justify-content : center;
    position        : absolute;
    @include size(24px);
    right           : 6px;
    bottom          : 9px;
    opacity         : .5;
    transition      : all .2s;
  }

  .bim-product-card__manufactirer-link:hover {
    opacity: 1;
  }

  .bim-product-card__manufactirer-link.big-wide {
    width: 36px;
    height: 36px;
  }

  .bim-product-card__manufactirer-image {
    width  : 100%;
    height : auto;
  }

  .bim-product-card__bottom {
    padding : 14px 8px 18px;
  }

  .bim-product-card__title {
    margin             : 0;
    @include text-style(13px, normal, 1.38, .19px, $black-color);
    display            : -webkit-box;
    -webkit-box-orient : vertical;
    -webkit-line-clamp : 4;
    overflow           : hidden;
    word-break         : break-word;
  }

  // Стили для широкой карточки
  .bim-product-card--wide {
    display        : flex;
    flex-direction : row;
    width          : 100% !important;
    height         : 105px !important;

    .bim-product-card__top {
      flex-shrink  : 0;
      width        : 105px;
      height       : auto;
      border       : none;
      border-right : 1px solid $white-color-300;;
    }

    .bim-product-card__image {
      @include size(77px);
      object-fit : contain;
      max-width  : 100%;
      max-height : 100%;
    }

    .bim-product-card__manufactirer-link {
      left   : 8px;
      bottom : 8px;
      right  : unset;
    }

    .bim-product-card__bottom {
      display        : flex;
      flex-direction : column;
      padding        : 14px;
    }

    .bim-product-card__title {
      margin             : 0 0 8px;
      padding            : 0;
      @include text-style(18px, bold, 1.44, normal, $black-color);
      -webkit-line-clamp : 2;
      @media screen and (max-width : $breakpoint-md) {
        font-size : 14px;
      }
    }

    .bim-product-card__category {
      @include text-style(10px, bold, 2, 1px, $black-color);
      opacity            : .5;
      text-transform     : uppercase;
      margin             : auto 0 0;
      display            : -webkit-box;
      -webkit-box-orient : vertical;
      -webkit-line-clamp : 1;
      overflow           : hidden;
      @media screen and (max-width : $breakpoint-md) {
        font-size          : 8px;
        margin             : 0;
        -webkit-line-clamp : 2;
      }
    }
  }

  /*самая большая карта*/
  .big-image-cnt {
    position: relative;
    overflow: hidden;
  }

  .bim-image-skelet {
    width: 100%;
    pointer-events: none;
    display: block;
    height: 100%;
  }

  .bim-image {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: auto;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  .bim-text-cnt {
    margin-top: 20px;
  }

  .big-card-title {
    margin-bottom: 12px;
    color: $black-color;
  }

  .big-card-desc {
    overflow: hidden;
    color: $black-color;
    margin-bottom: 20px;
  }

  .big-card-desc-text {
    line-height: 1.57 !important;
    display            : -webkit-box;
    -webkit-box-orient : vertical;
    -webkit-line-clamp : 6;
    overflow           : hidden;
    word-break         : break-word;
  }

  @media all and (min-width: $breakpoint-md) {
    .bim-card-big {
      display: flex;
    }
    .big-image-cnt {
      flex: 0.8;
    }
    .bim-text-cnt {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-left: 33px;
      margin-top: 0;
    }
    .big-card-title {
      flex: 0;
      margin-bottom: 14px;
    }
    .big-card-desc {
      flex: 1;
      overflow: hidden;
      margin-bottom: 24px;
    }
    .big-card-btn {
      flex: 0;
    }
  }
</style>
